export default "__VITE_ASSET__BIXXC0xv__"